import { useQuery } from "@tanstack/react-query";
import { fetchNews } from "@/services/newsService";

export function useNews(limit?: number) {
  return useQuery({
    queryKey: ["news"],
    queryFn: fetchNews,
    staleTime: 5 * 60 * 1000, // 5 minutes
    select: (data) => (limit ? data.slice(0, limit) : data),
  });
}
